import { Router } from '@angular/router';
import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, OnDestroy, OnChanges } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { SubTaskDetails } from 'src/app/data/models/subTaskDetails.model';
import { getSubTaskDetails } from '../../store/selectors/sub-task-details.selectors';
import { TaskStep } from 'src/app/data/models/task-step.model';
import { loadSubTaskDetails } from '../../store/actions/sub-task-details.actions';
import { getSubTaskList } from 'src/app/modules/superTask/task-state/reducers/task.reducer';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { updateStepStatusToInitialState } from '../../store/actions/step-status-update.actions';
import { SubTask } from 'app-models';
import * as Task from 'src/app/modules/superTask/task-state/actions/task.actions';
import * as RolesRouteMap from 'src/app/data/constants/roles';

@Component({
  selector: 'app-i140-subheader',
  templateUrl: './i140-subheader.component.html',
  styleUrls: ['./i140-subheader.component.scss']
})
export class I140SubheaderComponent implements OnInit, OnDestroy, OnChanges {

  @Input()
  inputSubheader;

  @Input()
  toggleSubTaskDetailsPanelBtn: boolean;

  @Output()
  subTaskPanelToggleEvent: EventEmitter<boolean> = new EventEmitter();

  @Output()
  onStepClick: EventEmitter<TaskStep> = new EventEmitter();


  subTaskToggleBtn: boolean;
  task: SubTaskDetails;
  stepDetails: TaskStep;
  isUpdateDecisionBtnDisabled: boolean;
  filingDate: string;
  observableSubscription$ = new Subject();
  userType: string;
  i485Present = true;
  ds260Present: boolean;

  constructor(
    private store: Store<any>,
    private router: Router) {
    this.subTaskToggleBtn = false;
    this.isUpdateDecisionBtnDisabled = true;
  }

  ngOnInit() {
    this.userType = sessionStorage.getItem('userTypeRole');
    this.store.pipe(select(getSubTaskList)).pipe(takeUntil(this.observableSubscription$)).subscribe((data: SubTask[]) => {
      this.i485Present =
        data && data.length > 0 ?
          data.some(task => task.taskTypeCode && task.taskTypeCode === 'I485') :
          false;
          this.ds260Present =
          data && data.length > 0 ?
            data.some(task => task.taskTypeCode && task.taskTypeCode === 'DS260') :
            false;
      this.filingDate = (data.find(x => x.taskTypeCode === 'I140')).filingDate;
      this.store.dispatch(loadSubTaskDetails({ taskId: parseInt(data.find(x => x.taskTypeCode === 'I140').id.toString()) }));

    });
    // Get Sub task Details
    this.store.pipe(select(getSubTaskDetails)).pipe(takeUntil(this.observableSubscription$)).subscribe((data: SubTaskDetails) => {
      this.task = data;

      if (this.task && this.task.id) {
        const submitPetitionStepDetails = this.task.taskStepDetails.find(x => x.stepActionList[0].layoutCode === 'GET_RECEIPT');
        if (submitPetitionStepDetails && submitPetitionStepDetails.stepStatusDetails &&
          submitPetitionStepDetails.stepStatusDetails.stepStatusCode === 'COMPLETE') {
          this.isUpdateDecisionBtnDisabled = false;
        }
      }
    });
  }

  ngOnChanges(e: SimpleChanges) {
    if (e.toggleSubTaskDetailsPanelBtn && e.toggleSubTaskDetailsPanelBtn.currentValue === false) {
      this.subTaskToggleBtn = e.toggleSubTaskDetailsPanelBtn.currentValue;
    }
  }

  handleUpdateDecision() {
    this.onStepClick.emit({ stepName: 'Update Decision' });
  }

  handleSendNotification() {
    this.onStepClick.emit({ stepName: 'Send Notification' });
  }

  toggleSubTask() {
    this.subTaskToggleBtn = !this.subTaskToggleBtn;
    this.subTaskPanelToggleEvent.emit(this.subTaskToggleBtn);
  }

  createI485Task() {
    this.store.dispatch(new Task.SetI485Petition(this.task));
    sessionStorage.removeItem('requestDataDocument');
    this.router.navigate([`${RolesRouteMap.userRoleRouteMapping[sessionStorage.getItem('userTypeRole')]}/dashboard/superTask/new`]);
  }

  createDS260Task(){
    this.store.dispatch(new Task.SetDS260Petition(this.task));
    this.router.navigate([`${RolesRouteMap.userRoleRouteMapping[sessionStorage.getItem('userTypeRole')]}/dashboard/superTask/new`]);
  }

  ngOnDestroy() {
    this.observableSubscription$.next();
    this.observableSubscription$.complete();
    // Update the Step Status state to empty state
    this.store.dispatch(updateStepStatusToInitialState());
  }

}
